import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import FormGroup from './FormGroup';
import { trimStart } from 'lodash';

const constructModel = (base, key) =>
  base ? `.${trimStart(base)}.${key}` : key;

export const AddressForm = ({ model, renderServerError }) => (
  <Fieldset model={model}>
    <FormGroup label="Address Line 1 *" model=".address_1">
      <Control.input updateOn="blur" model=".address_1" type="text" required />
      {renderServerError &&
        renderServerError(constructModel(model, 'address_1'))}
    </FormGroup>
    <FormGroup label="Address Line 2 *" model=".address_2">
      <Control.input updateOn="blur" model=".address_2" type="text" required />
      {renderServerError &&
        renderServerError(constructModel(model, 'address_2'))}
    </FormGroup>
    <FormGroup label="Town/City *" model=".city">
      <Control.input updateOn="blur" model=".city" type="text" required />
      {renderServerError && renderServerError(constructModel(model, 'city'))}
    </FormGroup>
    <FormGroup label="County *" model=".county">
      <Control.input updateOn="blur" model=".county" type="text" />
      {renderServerError && renderServerError(constructModel(model, 'county'))}
    </FormGroup>
    <FormGroup label="Postcode *" model=".postcode">
      <Control.input updateOn="blur" model=".postcode" type="text" />
      {renderServerError &&
        renderServerError(constructModel(model, 'postcode'))}
    </FormGroup>
    <FormGroup label="Country *" model=".country">
      <Control.input updateOn="blur" model=".country" type="text" required />
      {renderServerError && renderServerError(constructModel(model, 'country'))}
    </FormGroup>
  </Fieldset>
);

export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/common/Forms/AddressForm.jsx